// @flow

import React from "react";

import { WISTIA_VIDEOS } from "./video-codes";

const WISTIA_VIDEO_ID_PATTERN = "[A-Za-z0-9_-]+";
const WISTIA_VIDEO_URL_REGEXES = [
  new RegExp(`(?:https?:)?//(?:[\\w-]+\\.)?wistia\\.com/medias/(${WISTIA_VIDEO_ID_PATTERN})`, "gi"),
  new RegExp(
    `(?:https?:)?//fast\\.wistia\\.(?:net|com)/embed/iframe/(${WISTIA_VIDEO_ID_PATTERN})`,
    "gi",
  ),
  new RegExp(`wistia_async_(${WISTIA_VIDEO_ID_PATTERN})`, "gi"),
];

const extractIDFromText = (text: string): string[] => {
  const value = text || "";
  const videoIds: string[] = [];

  WISTIA_VIDEO_URL_REGEXES.forEach(regex => {
    value.replace(regex, (match, videoId) => {
      if (videoId && videoIds.indexOf(videoId) === -1) {
        videoIds.push(videoId);
      }

      return match;
    });
  });

  return videoIds;
};

type Props = $Exact<{
  videoId: string,
  title?: string,
  width?: string | number,
  height?: string | number,
}>;

const WistiaPlayer = ({ videoId, title, width, height }: Props) => {
  const iframeWidth = width == null ? "850" : width;
  const iframeHeight = height == null ? "480" : height;

  return videoId ? (
    <div className="responsive-wistia-player">
      <iframe
        width={iframeWidth}
        height={iframeHeight}
        src={`https://fast.wistia.net/embed/iframe/${videoId}?seo=false&resumable=false`}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title={title || "Wistia Video"}
      />
      <script src="https://fast.wistia.net/assets/external/E-v1.js" async />
    </div>
  ) : null;
};

WistiaPlayer.videos = WISTIA_VIDEOS;
WistiaPlayer.extractIDFromText = extractIDFromText;

export default WistiaPlayer;
